<div class="bg d-flex justify-content-end align-items-center">
    <header class="login-header">
        <mat-toolbar class="p-0">
            <nav class="navbar-header main-view w-100">
                <div class="header-right-32 d-flex justify-content-center p-0">
                    <div class="cursor mr-2">
                        <img alt="App Logo" src="assets/img/logo-hartmann.png" (click)="resetView()">
                    </div>
                </div>
            </nav>
        </mat-toolbar>

    </header>
    <app-login *ngIf="isLogin" (dataEvent)="onDataEvent($event)"></app-login>
    <app-registration *ngIf="isRegistration" (dataEvent)="onDataEvent($event)"></app-registration>
    <app-forgot-password *ngIf="isForgotPassword" (dataEvent)="onDataEvent($event)"></app-forgot-password>
    <div class="footer">
        <p>Version: v{{ appVersion }}</p>
    </div>
</div>